import { useRouter } from 'next/router';
import { useRecordIdOverride } from 'root/src/client/v2/common/hooks/recordIdOverride';
// Resolves the campaign recordId from the route (`router.query.recordId`). Pages on a clean URL with no
// `:recordId` segment (e.g. the demo dashboard) can supply one via `RecordIdOverrideProvider`; the route
// value always wins, and with no provider mounted the override is undefined so behavior is unchanged.
export function useRecordId() {
    var _a;
    const router = useRouter();
    const override = useRecordIdOverride();
    const { recordId } = router.query;
    return (_a = recordId) !== null && _a !== void 0 ? _a : override;
}
